import React from 'react';
import { Reset as ResetIcon } from '@solent-university/solent-icons';

import { Container, StyledIcon } from './Reset.styled';

export interface Props extends React.HTMLAttributes<HTMLElement> {
    ariaLabel: string;
    label: string;
}

const Reset: React.FC<Props> = props => {
    const { label, ariaLabel, ...rest } = props;

    return (
        <Container type="reset" variant="neutral" ariaLabel={ariaLabel} {...rest}>
            {label}
            <StyledIcon icon={ResetIcon} />
        </Container>
    );
};

export default Reset;
